/**
 * Matches US and Canada phone numbers
 * Allows for optional country code (+1), area code in parentheses, and various separators (spaces, dashes, dots)
 * @example
 * +1 (123) 456-7890
 * (123) 456-7890
 * 123-456-7890
 * 123.456.7890
 * 1234567890
 * 123 456 7890
 * 123-4567890
 * 123456-7890
*/
export const PHONE_NUMBER_REGEX = /^(?:\+?1[-. ]?)?(?:\(\d{3}\)|\d{3})[-. ]?\d{3}[-. ]?\d{4}$/
/**
 * Matches US postal codes
 * @example
 * 12345
 * 12345-6789
 * 12345 6789
*/
export const US_POSTAL_CODE_REGEX = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/
/**
 * Matches Canadian postal codes
 * Allows for optional space or dash between the first three and last three characters or no separator
 * @example
 * A1A 1A1
 * A1A-1A1
 * A1A1A1
*/
export const CANADA_POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
/**
 * Matches names with letters, numbers, spaces, hyphens, apostrophes, periods, and commas
 * @example
 * John Doe
 * O'Connor
 * Jean-Pierre
*/
export const NAME_REGEX = /^[a-zA-Z0-9_.+\- ]+$/
/**
 * Matches email addresses
 * @example
 * john.doe@example.com
 * jane_doe123@example.co.uk
 * user+name@example.org
*/
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
/**
 * Matches passwords with at least 12 characters, including at least one uppercase letter, one lowercase letter, one digit, and one special character
 * @example
 * Password123!
 * P@ssw0rd1234
*/
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{12,}$/

export default {
	PHONE_NUMBER_REGEX,
	US_POSTAL_CODE_REGEX,
	CANADA_POSTAL_CODE_REGEX,
	NAME_REGEX,
	EMAIL_REGEX,
	PASSWORD_REGEX
}
